/**
 * PageState — estados de carregamento, erro, vazio e conta não conectada,
 * iguais em todas as páginas de Marketing. Renderiza `children` quando nenhum
 * estado se aplica.
 *
 * Prioridade: loading > error > notConnected > empty > children.
 */
import Icon from './icons.jsx'

export default function PageState({
  loading, error, empty, notConnected,
  loadingText = 'Carregando dados...',
  emptyText = 'Sem dados para o período selecionado.',
  notConnectedText = 'Este cliente não tem conta conectada.',
  onRetry, children,
}) {
  if (loading) {
    return (
      <div className="dash-loading" role="status">
        <div className="dash-loading-spinner" />
        <p>{loadingText}</p>
      </div>
    )
  }
  if (error) {
    return (
      <div className="dash-error" role="alert">
        <Icon n="alert" s={20} />
        <p>Erro ao carregar dados: {typeof error === 'string' ? error : error.message || 'tente novamente'}</p>
        {onRetry && (
          <button className="dash-error-retry" onClick={onRetry} type="button">Tentar novamente</button>
        )}
      </div>
    )
  }
  if (notConnected) {
    return (
      <div className="dash-empty">
        <Icon n="link" s={22} />
        <p>{notConnectedText}</p>
      </div>
    )
  }
  if (empty) {
    return (
      <div className="dash-empty">
        <Icon n="alert" s={22} />
        <p>{emptyText}</p>
      </div>
    )
  }
  return children ?? null
}
